import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { quoteFormSelector } from 'ctm-selectors';
import { SummaryTable } from '../summary_table';
import { getRestrictionsLabel } from '../../products/summary/common/details/driver_restrictions';

const path = 'driver_option';

const _SummaryDriverRestrictions = (props) => {
    const { driverOption, isUpdated } = props;

    const restrictions = [
        {
            title: 'Driver restrictions',
            value: getRestrictionsLabel(driverOption)
        }
    ];

    return (
        <SummaryTable
            isUpdated={isUpdated}
            path={path}
            titleLabel={`Driver Restrictions ${isUpdated ? '- Updated' : ''}`}
            tableContent={restrictions}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        driverOption: quoteFormSelector(state).getIn(['coverDetail', 'driverOption']),
        isUpdated: state.getIn(['vertical', 'quote', 'form', `summaryPageEdit${path}`])
    };
};

_SummaryDriverRestrictions.propTypes = {
    driverOption: PropTypes.string,
    isUpdated: PropTypes.bool
};

const SummaryDriverRestrictions = connect(
    mapStateToProps,
)(_SummaryDriverRestrictions);

export { _SummaryDriverRestrictions, SummaryDriverRestrictions };
